import { render } from "./DetalheTransferencia.vue?vue&type=template&id=72709a33&scoped=true"
import script from "./DetalheTransferencia.vue?vue&type=script&lang=js"
export * from "./DetalheTransferencia.vue?vue&type=script&lang=js"

import "./DetalheTransferencia.vue?vue&type=style&index=0&id=72709a33&scoped=true&lang=css"
import "./DetalheTransferencia.vue?vue&type=style&index=1&id=72709a33&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72709a33"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QSelect,QBtn,QTable,QImg,QTd,QRadio,QDialog,QCard,QCardSection,QCardActions,QSeparator,QField});qInstall(script, 'directives', {ClosePopup});
